unit UAbwList;

interface

uses
  System.Contnrs, UAbwModel, UEssentialHelper;

type
  TAbwList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    function GetItem(i: Integer): TAbwModel;
    procedure Add(item: TAbwModel);
    procedure PropertyChanged;
    procedure SetValues(json: string);
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    function IndexOf(id: Integer): Integer; overload;
    function IndexOf(bezeichnung: string): Integer; overload;
    procedure GetAll(url: string);
    property Items[i: Integer]: TAbwModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged write SetOnPropertyChanged;
  end;

implementation

uses
  Js, System.SysUtils, WebLib.REST;

{ TAbwList }

procedure TAbwList.Add(item: TAbwModel);
begin
  inherited Add(item);
end;

procedure TAbwList.GetAll(url: string);
var client: TRestClient;
  procedure Response(Sender: TObject; AResponse: string);
  var jso: TJsObject;
  begin
    Self.Clear;
    jso:=TJsJson.parseObject(AResponse);
    if jso['value']<>nil then
      Self.SetValues(string(jso['value']));
    Self.PropertyChanged;
  end;
begin
  client:=TRestClient.Create(nil);
  client.OnResponse:=Response;
  client.HttpsGet(url+'/HolidayService/GetAllAbw');
  client.Free;
end;

function TAbwList.GetItem(i: Integer): TAbwModel;
begin
  Result:=inherited GetItem(i) as TAbwModel;
end;

function TAbwList.IndexOf(bezeichnung: string): Integer;
var i: Integer;
    found: Boolean;
begin
  found:=false;
  i:=0;
  while not found and (i<Self.Count) do
    if Self.Items[i].Bezeichnung=bezeichnung then
      found:=true
    else
      Inc(i);
  if found then
    Result:=i
  else
    Result:=-1;
end;

function TAbwList.IndexOf(id: Integer): Integer;
var i: Integer;
    found: Boolean;
begin
  found:=false;
  i:=0;
  while not found and (i<Self.Count) do
    if Self.Items[i].Id=id then
      found:=true
    else
      Inc(i);
  if found then
    Result:=i
  else
    Result:=-1;
end;

procedure TAbwList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TAbwList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TAbwList.SetValues(json: string);
var obj: TJsObject;
    i, count: Integer;
begin
  Self.Clear;
  obj:=TJsJson.parseObject(json);
  if obj['Count']<>nil then begin
    count:=StrToInt(string(obj['Count']));
    for i:=0 to count-1 do
      if obj['Item'+IntToStr(i)]<>nil then
        Self.Add(TAbwModel.Create(string(obj['Item'+IntToStr(i)])));
  end;
end;

end.
